function sfm(e) {
    if (e.matches) {
      return true;
    }
    else{
      return false;
    }
}

var sf_style = window.matchMedia("(min-width: 768px)");
sf_style.addListener(sfm);
sfm(sf_style);


function menu() {
  $(".js-mob-menu-open").on("click", function(){
    var target = $(this).data("target");
    openMobMenu(target);
  })



  $(".js-fader, .js-mob-menu-close").on("click", function () {
    if (!sfm(sf_style)) closeOpenedMenu();
  });

  $(document).on("click", function (e) {
    var menu_div = $(".main-nav__item *, div.subcontent");
    var submen=$(".js-services-list-item-sb");
    if (sfm(sf_style) && $("body").hasClass("no-overflow") && !menu_div.is(e.target) && menu_div.has(e.target).length === 0) {
      closeOpenedMenu();
    }
    if(sfm(sf_style) && !submen.is(e.target) && submen.has(e.target).length === 0 && submen.find(".submenu")){
      submen.find(".submenu").fadeOut("fast");
    }
  });


    fixOnScroll($(".js-mob-menu-open"));
    fixOnScroll($(".header__right"));


  function fixOnScroll(el){
    var elTop = el.offset().top;
    $(window).on("scroll", function(){
      if ($(window).width() < 768) {
        if ($(window).scrollTop() > elTop) {
          el.addClass("fixed");
        } else {
          el.removeClass("fixed");
        }
      }
    })

  }

  function openMobMenu(target) {
    var targetObj = $(`.js-mob-menu[data-menu="${target}"]`)
    $(".js-fader").fadeIn("300");
    $("body").addClass("no-overflow");
    targetObj.css({
      "transform" : "translateX(0)",
      "transition": "transform 0.3s"
    })
    targetObj.addClass("menu-opened")
    $(window).trigger("scroll")
    if(targetObj.data("scroll") != undefined) {
      var scrollCont = targetObj.children(".scrollable");
      new PerfectScrollbar(scrollCont[0], {
        suppressScrollX: true
      });
    }


  }
  function closeOpenedMenu(){
    $(".js-fader").fadeOut("300");
    $("body").removeClass("no-overflow");
    $("body").css({"padding-right": "0"});
    $(".menu-opened").css({
      "transform" : "translateX(-150%)"
    })
  }
}
